angular.module('gym.reports').controller('ScheduleExportsCtrl', ["$scope", "$modalInstance", "$http", "report", "exportId", function($scope, $modalInstance, $http, report, exportId) {
  var exportsResource, loadExport, save;
  $scope.report = report;
  exportsResource = $scope.report.all('export_schedules');
  exportsResource.doGET('new').then(function(data) {
    var defaultPreferredHours, ref;
    defaultPreferredHours = _.find(data.preferred_hours_options, function(item) {
      return item[1] === '12pm';
    }) || _.find(data.preferred_hours_options, function(item) {
      return item[1] === '1pm';
    }) || data.preferred_hours_options[0];
    if (!((ref = $scope.data.preferred_hours) != null ? ref.length : void 0)) {
      $scope.data.preferred_hours = [defaultPreferredHours[0]];
    }
    return $scope.preferredHoursOptions = data.preferred_hours_options.map(function(item) {
      return {
        id: item[0],
        name: item[1]
      };
    });
  });
  $scope.currentUser = window.currentUser;
  $scope.data = {
    rootObjectName: 'report_export_schedule',
    recurring_frequency_number: 1,
    recurring_frequency_unit: 'day',
    preferred_hours: report.preferred_hours || []
  };
  loadExport = function() {
    if (exportId) {
      return $scope.report.one('export_schedules', exportId).get().then(function(data) {
        $scope.data = data;
        return $scope.data.rootObjectName = 'report_export_schedule';
      });
    }
  };
  loadExport();
  $scope.days = (function() {
    var results = [];
    for (var i = 1; i <= 30; i++){ results.push(i); }
    return results;
  }).apply(this);
  $scope.wdays = [[0, 'sunday'], [1, 'monday'], [2, 'tuesday'], [3, 'wednesday'], [4, 'thursday'], [5, 'friday'], [6, 'saturday']];
  $scope.units = [['day', 'day(s)'], ['week', 'week(s)'], ['month', 'month(s)']];
  $scope.onRecurringFrequencyUnitChange = function() {
    $scope.data.wday = void 0;
    $scope.data.day_of_month = void 0;
    if ($scope.data.recurring_frequency_unit === 'week') {
      $scope.data.wday = 0;
    }
    if ($scope.data.recurring_frequency_unit === 'month') {
      return $scope.data.day_of_month = 1;
    }
  };
  save = function() {
    if ($scope.data.id) {
      return $scope.data.save();
    } else {
      return exportsResource.post($scope.data);
    }
  };
  $scope.submit = function() {
    $scope.errors = {};
    $scope.isLoading = true;
    return save().then(function() {
      return $modalInstance.close();
    }, function(response) {
      $scope.errors = response.data.errors;
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
